/**
 * Legenda carta HTML statik (pengganti <Legend/> Recharts).
 * Recharts <Legend/> mengukur kedudukan DOM (useElementOffset) dan boleh menyebabkan
 * "Maximum update depth exceeded" pada skrin mudah alih / React 19. Komponen ini tidak mengukur DOM.
 * items: [{ label, color, type: "line" | "square", dashed }]
 */
export default function ChartLegend({ items = [], fontSize = 12, className = "" }) {
  const list = items.filter((it) => it && it.label);
  if (!list.length) return null;
  return (
    <ul className={`flex flex-wrap justify-center gap-x-4 gap-y-1 mt-1 ${className}`} style={{ fontSize }} data-testid="chart-legend">
      {list.map((it, i) => (
        <li key={`${it.label}-${i}`} className="flex items-center gap-1.5" style={{ color: it.color }} data-testid="chart-legend-item">
          {it.type === "line" ? (
            <svg width="16" height="10" aria-hidden="true">
              <line x1="0" y1="5" x2="16" y2="5" stroke={it.color} strokeWidth="2" strokeDasharray={it.dashed ? "4 2" : undefined} />
              <circle cx="8" cy="5" r="3" fill="#fff" stroke={it.color} strokeWidth="1.5" />
            </svg>
          ) : (
            <span className="inline-block w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: it.color }} />
          )}
          <span>{it.label}</span>
        </li>
      ))}
    </ul>
  );
}
